import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SqlModeService } from '../services/sql-mode.service';

@Injectable()
export class SqlModeInterceptor implements HttpInterceptor {
  constructor(private sqlModeService: SqlModeService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Backend se flag milta hai ya message me ONLY_FULL_GROUP_BY hai
        if (
          (error?.error?.data?.allowFixSqlMode === true) ||
          (error?.error?.message && error.error.message.includes('ONLY_FULL_GROUP_BY'))
        ) {
          this.sqlModeService.showFixButton();
        }
        return throwError(() => error);
      })
    );
  }
}
